class ProductPricing {
  public readonly flatRate: number;
  public readonly taxRate: number;
  public readonly currency: string;
  public readonly expirationDays: number;
  constructor({
    flatRate,
    taxRate,
    currency,
    expirationDays,
  }: {
    flatRate: number;
    taxRate: number;
    currency: string;
    expirationDays: number;
  }) {
    this.flatRate = flatRate;
    this.taxRate = taxRate;
    this.currency = currency;
    this.expirationDays = expirationDays;
  }

  public static fromJSON = (value: any) => {
    const { flat_rate, tax_rate, currency, expiration_days } = Object.assign({}, value);
    const flatRate = flat_rate;
    const taxRate = tax_rate;
    const expirationDays = expiration_days;

    if (typeof flatRate !== 'number') throw new TypeError('.flatRate must be a number');
    if (typeof taxRate !== 'number') throw new TypeError('.taxRate must be a number');
    if (typeof currency !== 'string') throw new TypeError('.currency must be a string');
    if (typeof expirationDays !== 'number') throw new TypeError('.expirationDays must be a number');

    return new ProductPricing({
      flatRate,
      taxRate,
      currency,
      expirationDays,
    });
  };
}

export default ProductPricing;
